import { upperFirst } from 'lodash';

export default class LoginViewState {
  static isPrototypeInitialized = false;

  buildWithMethods() {
    if (!LoginViewState.isPrototypeInitialized) {
      const proto = Object.getPrototypeOf(this); // eslint-disable-line prefer-reflect
      for (const field in this) {
        if (this.hasOwnProperty(field)) {
          proto[`with${upperFirst(field)}`] = function (value) {
            return this.copyWith(field, value);
          };
        }
      }

      LoginViewState.isPrototypeInitialized = true;
    }
  }

  constructor(
    isEmailFormVisible = false,
    isBackToSignInButtonVisible = false,
    isShowSignInPanelCompanyVisible = false,
    isShowSignInPanelVisible = false,
    isShowSignUpPanelVisible = false,
    isSignInModalPanelVisible = false,
    isErrorVisible = false,
    headingText = null,
    screenName = null,
    subheadingText = null,
    subcontextText = null,
    email = null,
    federatedConnection = null,
    lockState = null
  ) {
    this.isEmailFormVisible = isEmailFormVisible;
    this.isBackToSignInButtonVisible = isBackToSignInButtonVisible;
    this.isShowSignInPanelCompanyVisible = isShowSignInPanelCompanyVisible;
    this.isShowSignInPanelVisible = isShowSignInPanelVisible;
    this.isShowSignUpPanelVisible = isShowSignUpPanelVisible;
    this.isSignInModalPanelVisible = isSignInModalPanelVisible;
    this.isErrorVisible = isErrorVisible;
    this.headingText = headingText;
    this.screenName = screenName;
    this.subheadingText = subheadingText;
    this.subcontextText = subcontextText;
    this.email = email;
    this.federatedConnection = federatedConnection;
    this.lockState = lockState;

    this.buildWithMethods();
  }

  copyWith(field, value) {
    const result = new LoginViewState(
      this.isEmailFormVisible,
      this.isBackToSignInButtonVisible,
      this.isShowSignInPanelCompanyVisible,
      this.isShowSignInPanelVisible,
      this.isShowSignUpPanelVisible,
      this.isSignInModalPanelVisible,
      this.isErrorVisible,
      this.headingText,
      this.screenName,
      this.subheadingText,
      this.subcontextText,
      this.email,
      this.federatedConnection,
      this.lockState
    );
    result[field] = value;
    return result;
  }

  withText(text) {
    return this.withHeadingText(text.heading)
      .withSubheadingText(text.subheading)
      .withSubcontextText(text.subcontext);
  }
}
